import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

type RuleNames =
  | 'formAddress'
  | 'formAddressInput';

export const formWrapper = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridGap: '28px',
  justifyContent: 'space-between',
};

export const borderInput = {
  '& fieldset': { borderColor: '#3B5D3E' },
  '& label': { color: '#0B170C' },
};

export const infoForm = {
  display: 'flex',
  flexDirection: 'column',
  gap: '28px',
  '& .MuiInputBase-input[type=number]::-webkit-inner-spin-button, & .MuiInputBase-input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& label.Mui-focused': {
    color: 'black',
  },
};

const PREFIX = 'FormAddress';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      formAddress: {
        '& .MuiPaper-root': {
          position: 'absolute',
          top: '55px',
          zIndex: 100,
        },
        '& .MuiButtonBase-root': {
          background: theme.white,
          height: '40px',
          width: '100%',
          transition: 'background-color 0.1s ease',
          cursor: 'pointer',
          color: '#000000',
        },
        '& .MuiButtonBase-root:hover': {
          background: '#D2D4D7',
        },
      },
      formAddressInput: {
        border: '1px solid red',
        borderRadius: '4px',
      },
    }
  ),
  { name: PREFIX },
);
